import { Link, matchPath, useLocation } from "react-router-dom";
import sidebarLogo from "../../assets/images/logo.png";
import { useEffect, useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import { usePermission } from "../../hooks/usePermission";
import { APP, appText } from "../../constant/theme";

const Sidebar = () => {
  const { user } = useApplicationContext();
  const { hasPermission } = usePermission();

  const closeDrawer = () => {
    document.body.classList.remove("sidebar-open");
  };

  const isSuperAdmin = user?.user_type === 1 ? 1 : 0;
  const isCountryAdmin = user?.user_type === 6 ? 1 : 0;
  const isStateAdmin = user?.user_type === 7 ? 1 : 0;
  const isRegionAdmin = user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = user?.user_type === 3 ? 1 : 0;

  const location = useLocation();
  const isParentPath = (url) => matchPath(url, location.pathname) != null;

  const [showMastersSubMenu, setShowMastersSubMenu] = useState(false);
  const [showReportsSubMenu, setShowReportsSubMenu] = useState(false);
  const [showVisitorsSubMenu, setShowVisitorsSubMenu] = useState(false);
  const [showFinanceSubMenu, setShowFinanceSubMenu] = useState(false);

  const dashboardRoute = () =>
    isParentPath("/") || isParentPath("/home") || isParentPath("/dashboard");

  const userRoutes = () =>
    isParentPath("/users") ||
    isParentPath("/user/create") ||
    isParentPath("/user/:id/edit");

  const regionRoutes = () =>
    isParentPath("/regions") ||
    isParentPath("/create/region") ||
    isParentPath("/region/:id/edit");

  const countryRoutes = () =>
    isParentPath("/countries") ||
    isParentPath("/create/country") ||
    isParentPath("/country/:id/edit");

  const stateRoutes = () =>
    isParentPath("/states") ||
    isParentPath("/create/state") ||
    isParentPath("/state/:id/edit");

  const chapterRoutes = () =>
    isParentPath("/chapters") ||
    isParentPath("/create/chapter") ||
    isParentPath("/chapter/:id/edit");

  const countryAdminRoutes = () =>
    isParentPath("/country-admin-users") ||
    isParentPath("/country-admin-user/create") ||
    isParentPath("/country-admin-user/:id/edit");

  const stateAdminRoutes = () =>
    isParentPath("/state-admin-users") ||
    isParentPath("/state-admin-user/create") ||
    isParentPath("/state-admin-user/:id/edit");

  const regionAdminRoutes = () =>
    isParentPath("/region-admin-users") ||
    isParentPath("/region-admin-user/create") ||
    isParentPath("/region-admin-user/:id/edit");

  const chapterAdminRoutes = () =>
    isParentPath("/chapter-admin-users") ||
    isParentPath("/chapter-admin-user/create") ||
    isParentPath("/chapter-admin-user/:id/edit");

  const categoryRoutes = () =>
    isParentPath("/category") ||
    isParentPath("/create/category") ||
    isParentPath("/category/:id/edit");

  const incomeCategoryRoutes = () =>
    isParentPath("/income-category") ||
    isParentPath("/create/income-category") ||
    isParentPath("/income-category/:id/edit");

  const expenseCategoryRoutes = () =>
    isParentPath("/expense-category") ||
    isParentPath("/create/expense-category") ||
    isParentPath("/expense-category/:id/edit");

  const postsCategoryRoutes = () =>
    isParentPath("/posts-category") ||
    isParentPath("/create/posts-category") ||
    isParentPath("/posts-category/:id/edit");

  const sponsorsCategoryRoutes = () =>
    isParentPath("/sponsors-category") ||
    isParentPath("/create/sponsors-category") ||
    isParentPath("/sponsors-category/:id/edit");

  const bloodgroupRoutes = () =>
    isParentPath("/blood-groups") ||
    isParentPath("/create/blood-group") ||
    isParentPath("/blood-group/:id/edit");

  const habitsRoutes = () =>
    isParentPath("/habits") ||
    isParentPath("/create/habit") ||
    isParentPath("/habit/:id/edit");

  const crownRoutes = () =>
    isParentPath("/crowns") ||
    isParentPath("/create/crown") ||
    isParentPath("/crown/:id/edit");

  const timerRoutes = () =>
    isParentPath("/timers") ||
    isParentPath("/create/timer") ||
    isParentPath("/timer/:id/edit");

  const timerAccessRoutes = () => isParentPath("/timer-access");

  const chapterFinanceAccessRoutes = () =>
    isParentPath("/chapter-finance-access");

  const roleRoutes = () =>
    isParentPath("/roles") ||
    isParentPath("/create/role") ||
    isParentPath("/role/:id/edit");

  const userRoleRoutes = () =>
    isParentPath("/user-roles") ||
    isParentPath("/create/user-role") ||
    isParentPath("/user-role/:id/edit");

  const tyfcbRoutes = () => isParentPath("/tyfcbs");

  const testimonialsRoutes = () => isParentPath("/testimonials");

  const meetingSchedulesRoutes = () => isParentPath("/meeting-schedules");

  const meetingAttendanceRoutes = () => isParentPath("/weekly-meetings");

  const MeetingFeesRoutes = () => isParentPath("/meeting-fees");

  const weeklyMeetingFeesRoutes = () => isParentPath("/meeting-fees");

  const onetooneRoutes = () => isParentPath("/one-to-one");

  const referralRoutes = () => isParentPath("/referrals");

  const visitorGeneralRoutes = () => isParentPath("/visitors/general");

  const visitorChiefGuestRoutes = () => isParentPath("/visitors/chief-guest");

  const visitorPowerDateRoutes = () => isParentPath("/visitors/power-date");

  const visitorInductionsRoutes = () => isParentPath("/visitors/inductions");

  const eventRoutes = () =>
    isParentPath("/events") ||
    isParentPath("/create/event") ||
    isParentPath("/event/:id/edit");

  const newsRoutes = () =>
    isParentPath("/news") ||
    isParentPath("/news/create") ||
    isParentPath("/news/:id/edit");

  const feedPostsRoutes = () => isParentPath("/feed-posts");

  const incomesRoutes = () => isParentPath("/incomes");

  const expensesRoutes = () => isParentPath("/expenses");

  const sponsorsRoutes = () => isParentPath("/sponsors");

  const financeRoutes = () =>
    isParentPath("/incomes") ||
    isParentPath("/expenses") ||
    isParentPath("/sponsors");

  const pointsRoutes = () => isParentPath("/points");

  const pointsSystemRoutes = () => isParentPath("/points-system");

  const settingsRoutes = () =>
    isParentPath("/attendance-qr-code") || isParentPath("/settings");

  const forumSettingsRoutes = () => isParentPath("/forum-settings");
  const memberMonthlyReportsRoutes = () =>
    isParentPath("/member_monthly_reports");

  const tyfcbReportsRoutes = () => isParentPath("/reports/tyfcbs");

  const bizgivenReportsRoutes = () => isParentPath("/reports/biz-given");

  const onetooneReportsRoutes = () => isParentPath("/reports/one-to-one");

  const referralReportsRoutes = () => isParentPath("/reports/referrals");

  const visitorsReportsRoutes = () => isParentPath("/reports/visitors");

  const visitorsGeneralReportsRoutes = () =>
    isParentPath("/reports/visitors-general");

  const visitorsChiefGuestReportsRoutes = () =>
    isParentPath("/reports/visitors-chief-guest");

  const visitorsPowerDateReportsRoutes = () =>
    isParentPath("/reports/visitors-power-date");

  const visitorsInductionReportsRoutes = () =>
    isParentPath("/reports/visitors-inductions");

  const feesReportsRoutes = () => isParentPath("/reports/fees");

  const overallReportsRoutes = () => isParentPath("/reports/overall");

  const ledgerReportsRoutes = () => isParentPath("/reports/ledger");

  const membershipExpiryRenewalReportsRoutes = () =>
    isParentPath("/reports/membership-expiry-renewals");

  const attendanceReportsRoutes = () => isParentPath("/reports/attendance");

  const chapterWiseBusinessReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-business");

  const chapterWiseOnetoOneReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-one-to-one");

  const chapterWiseReferralsReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-referrals");

  const chapterWiseVisitorsReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-visitors");

  const categoryWiseMembersReportsRoutes = () =>
    isParentPath("/reports/category-wise-members");

  useEffect(() => {
    if (
      isParentPath("/reports/tyfcbs") ||
      isParentPath("/reports/biz-given") ||
      isParentPath("/reports/one-to-one") ||
      isParentPath("/reports/referrals") ||
      isParentPath("/reports/visitors") ||
      isParentPath("/reports/visitors-general") ||
      isParentPath("/reports/visitors-chief-guest") ||
      isParentPath("/reports/visitors-power-date") ||
      isParentPath("/reports/visitors-inductions") ||
      isParentPath("/reports/fees") ||
      isParentPath("/reports/attendance") ||
      isParentPath("/reports/overall") ||
      isParentPath("/reports/ledger") ||
      isParentPath("/reports/membership-expiry-renewals") ||
      isParentPath("/reports/chapter-wise-business") ||
      isParentPath("/reports/chapter-wise-one-to-one") ||
      isParentPath("/reports/chapter-wise-referrals") ||
      isParentPath("/reports/chapter-wise-visitors") ||
      isParentPath("/reports/category-wise-members") ||
      isParentPath("/reports/points")
    ) {
      setShowReportsSubMenu(true);
    } else {
      setShowReportsSubMenu(false);
    }

    if (
      isParentPath("/visitors/general") ||
      isParentPath("/visitors/chief-guest") ||
      isParentPath("/visitors/power-date") ||
      isParentPath("/visitors/inductions")
    ) {
      setShowVisitorsSubMenu(true);
    } else {
      setShowVisitorsSubMenu(false);
    }

    if (
      isParentPath("/incomes") ||
      isParentPath("/expenses") ||
      isParentPath("/sponsors")
    ) {
      setShowFinanceSubMenu(true);
    } else {
      setShowFinanceSubMenu(false);
    }

    if (
      isParentPath("/countries") ||
      isParentPath("/create/country") ||
      isParentPath("/region/:id/country") ||
      isParentPath("/states") ||
      isParentPath("/create/state") ||
      isParentPath("/region/:id/state") ||
      isParentPath("/regions") ||
      isParentPath("/create/region") ||
      isParentPath("/region/:id/edit") ||
      isParentPath("/country-admin-users") ||
      isParentPath("/country-admin-user/create") ||
      isParentPath("/country-admin-user/:id/edit") ||
      isParentPath("/state-admin-users") ||
      isParentPath("/state-admin-user/create") ||
      isParentPath("/state-admin-user/:id/edit") ||
      isParentPath("/region-admin-users") ||
      isParentPath("/region-admin-user/create") ||
      isParentPath("/region-admin-user/:id/edit") ||
      isParentPath("/chapters") ||
      isParentPath("/create/chapter") ||
      isParentPath("/chapter/:id/edit") ||
      isParentPath("/chapter-admin-users") ||
      isParentPath("/chapter-admin-user/create") ||
      isParentPath("/chapter-admin-user/:id/edit") ||
      isParentPath("/blood-groups") ||
      isParentPath("/create/blood-group") ||
      isParentPath("/blood-group/:id/edit") ||
      isParentPath("/habits") ||
      isParentPath("/create/habit") ||
      isParentPath("/habit/:id/edit") ||
      isParentPath("/timers") ||
      isParentPath("/create/timer") ||
      isParentPath("/timer/:id/edit") ||
      isParentPath("/timer-access") ||
      isParentPath("/chapter-finance-access") ||
      isParentPath("/category") ||
      isParentPath("/create/category") ||
      isParentPath("/category/:id/edit") ||
      isParentPath("/income-category") ||
      isParentPath("/create/income-category") ||
      isParentPath("/income-category/:id/edit") ||
      isParentPath("/expense-category") ||
      isParentPath("/create/expense-category") ||
      isParentPath("/expense-category/:id/edit") ||
      isParentPath("/posts-category") ||
      isParentPath("/create/posts-category") ||
      isParentPath("/posts-category/:id/edit") ||
      isParentPath("/sponsors-category") ||
      isParentPath("/create/sponsors-category") ||
      isParentPath("/sponsors-category/:id/edit") ||
      isParentPath("/crowns") ||
      isParentPath("/create/crown") ||
      isParentPath("/crown/:id/edit") ||
      isParentPath("/user-roles") ||
      isParentPath("/create/user-role") ||
      isParentPath("/user-role/:id/edit")
    ) {
      setShowMastersSubMenu(true);
    } else {
      setShowMastersSubMenu(false);
    }
  }, [location]);

  const toggleMastersSubMenu = () => {
    setShowMastersSubMenu(!showMastersSubMenu);
  };

  const toggleReportsSubMenu = () => {
    setShowReportsSubMenu(!showReportsSubMenu);
  };

  const toggleVisitorsSubMenu = () => {
    setShowVisitorsSubMenu(!showVisitorsSubMenu);
  };

  const toggleFinanceSubMenu = () => {
    setShowFinanceSubMenu(!showFinanceSubMenu);
  };

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme darkbg"
    >
      <div className="sidebar-heading d-flex align-items-center justify-content-between px-3 py-3 border-bottom border-opacity-10">
        <Link to="/" className="flex-grow-1 d-flex justify-content-center">
          <span className="sidebar-logo-chip">
            <img
              src={sidebarLogo}
              alt={appText(APP.logoAlt)}
              className="img-fluid"
              style={{ maxWidth: "150px", height: "auto", objectFit: "contain" }}
            />
          </span>
        </Link>
        <button
          type="button"
          className="sidebar-close-btn d-lg-none ms-2"
          aria-label="Close sidebar"
          onClick={closeDrawer}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div className="list-group list-group-flush mt-2">
        <Link
          to="/dashboard"
          onClick={closeDrawer}
          className={`list-group-item list-group-item-action d-flex align-items-center ${dashboardRoute() ? "active" : ""}`}
        >
          <i className="fa-solid fa-gauge-high fa-fw me-3"></i>
          <span>Dashboard</span>
        </Link>

        {hasPermission("members-list") && (
          <Link
            to="/users"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${userRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-users fa-fw me-3"></i>
            <span>Members</span>
          </Link>
        )}

        {hasPermission("meeting-schedules-list") && (
          <Link
            to="/weekly-meetings"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${meetingAttendanceRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-calendar-check fa-fw me-3"></i>
            <span>Meeting Schedules</span>
          </Link>
        )}

        {hasPermission("meeting-fees-list") && (
          <Link
            to="/meeting-fees"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${MeetingFeesRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-calendar-days fa-fw me-3"></i>
            <span>Meeting Fees</span>
          </Link>
        )}

        {hasPermission("121s-list") && (
          <Link
            to="/one-to-one"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${onetooneRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-comments fa-fw me-3"></i>
            <span>121s</span>
          </Link>
        )}

        {hasPermission("referrals-list") && (
          <Link
            to="/referrals"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${referralRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-hand-holding-dollar fa-fw me-3"></i>
            <span>RFLs</span>
          </Link>
        )}

        {hasPermission("tyfcbs-list") && (
          <Link
            to="/tyfcbs"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${tyfcbRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-link fa-fw me-3"></i>
            <span>TYNs</span>
          </Link>
        )}

        {(hasPermission("visitors-general-list") ||
          hasPermission("visitors-chief-guest-list") ||
          hasPermission("visitors-power-date-list") ||
          hasPermission("visitors-inductions-list")) && (
          <div className={`sidebar-dropdown-menu ${showVisitorsSubMenu ? "open" : ""}`}>
            <div
              className="sidebar-dropdown-toggle d-flex justify-content-between align-items-center"
              onClick={toggleVisitorsSubMenu}
            >
              <div className="d-flex align-items-center">
                <span className="sidebar-icon-wrap me-3">
                  <i className="fa-solid fa-user-plus"></i>
                </span>
                <span className="dropdown-item-text">Visitors</span>
              </div>
              <i className="fa-solid fa-chevron-down dropdown-arrow ms-2 flex-shrink-0"></i>
            </div>
            <div className="sidebar-submenu-collapse">
              <div className="sidebar-submenu-card">
                {hasPermission("visitors-general-list") && (
                  <Link
                    to="/visitors/general"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${visitorGeneralRoutes() ? "active" : ""}`}
                  >
                    General
                  </Link>
                )}
                {hasPermission("visitors-chief-guest-list") && (
                  <Link
                    to="/visitors/chief-guest"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${visitorChiefGuestRoutes() ? "active" : ""}`}
                  >
                    Chief Guest
                  </Link>
                )}
                {hasPermission("visitors-inductions-list") && (
                  <Link
                    to="/visitors/inductions"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${visitorInductionsRoutes() ? "active" : ""}`}
                  >
                    Inductions
                  </Link>
                )}
                {hasPermission("visitors-power-date-list") && (
                  <Link
                    to="/visitors/power-date"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${visitorPowerDateRoutes() ? "active" : ""}`}
                  >
                    Power Date
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}

        {hasPermission("buddy-pairs-list") && (
          <Link
            to="/buddy-pairs"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${isParentPath("/buddy-pairs") ? "active" : ""}`}
          >
            <i className="fa-solid fa-user-group fa-fw me-3"></i>
            <span>Buddy Pairs</span>
          </Link>
        )}

        {hasPermission("buddy-habit-report-list") && (
          <Link
            to="/buddy-habit-report"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${isParentPath("/buddy-habit-report") ? "active" : ""}`}
          >
            <i className="fa-solid fa-clipboard-check fa-fw me-3"></i>
            <span>Buddy Habit Report</span>
          </Link>
        )}

        {hasPermission("complaints-list") && (
          <Link
            to="/complaints"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${isParentPath("/complaints") ? "active" : ""}`}
          >
            <i className="fa-solid fa-flag fa-fw me-3"></i>
            <span>Complaints</span>
          </Link>
        )}

        {hasPermission("complaints-list") && (
          <Link
            to="/grievances"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${isParentPath("/grievances") ? "active" : ""}`}
          >
            <i className="fa-solid fa-scale-balanced fa-fw me-3"></i>
            <span>Grievances</span>
          </Link>
        )}

        {hasPermission("events-list") && (
          <Link
            to="/events"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${eventRoutes() ? "active" : ""}`}
          >
            <i className="fa-regular fa-calendar fa-fw me-3"></i>
            <span>Events</span>
          </Link>
        )}

        {hasPermission("news-list") && (
          <Link
            to="/news"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${newsRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-newspaper fa-fw me-3"></i>
            <span>News Feed</span>
          </Link>
        )}

        {hasPermission("feed-posts-list") && (
          <Link
            to="/feed-posts"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${feedPostsRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-bullseye fa-fw me-3"></i>
            <span>Leads</span>
          </Link>
        )}

        {(hasPermission("incomes-list") ||
          hasPermission("expenses-list") ||
          hasPermission("sponsors-list")) && (
          <div className={`sidebar-dropdown-menu ${showFinanceSubMenu ? "open" : ""}`}>
            <div
              className="sidebar-dropdown-toggle d-flex justify-content-between align-items-center"
              onClick={toggleFinanceSubMenu}
            >
              <div className="d-flex align-items-center">
                <span className="sidebar-icon-wrap me-3">
                  <i className="fa-solid fa-coins"></i>
                </span>
                <span className="dropdown-item-text">Finance</span>
              </div>
              <i className="fa-solid fa-chevron-down dropdown-arrow ms-2 flex-shrink-0"></i>
            </div>
            <div className="sidebar-submenu-collapse">
              <div className="sidebar-submenu-card">
                {hasPermission("incomes-list") && (
                  <Link
                    to="/incomes"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${incomesRoutes() ? "active" : ""}`}
                  >
                    Incomes
                  </Link>
                )}
                {hasPermission("expenses-list") && (
                  <Link
                    to="/expenses"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${expensesRoutes() ? "active" : ""}`}
                  >
                    Expenses
                  </Link>
                )}
                {hasPermission("sponsors-list") && (
                  <Link
                    to="/sponsors"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${sponsorsRoutes() ? "active" : ""}`}
                  >
                    Sponsors
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}

        {hasPermission("testimonials-list") && (
          <Link
            to="/testimonials"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${testimonialsRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-comment-dots fa-fw me-3"></i>
            <span>Testimonials</span>
          </Link>
        )}

        {(hasPermission("reports-tyns-list") ||
          hasPermission("reports-biz-given-list") ||
          hasPermission("reports-121s-list") ||
          hasPermission("reports-referrals-list") ||
          hasPermission("reports-visitors-list") ||
          hasPermission("reports-visitors-general-list") ||
          hasPermission("reports-visitors-chief-guest-list") ||
          hasPermission("reports-visitors-power-date-list") ||
          hasPermission("reports-visitors-inductions-list") ||
          hasPermission("reports-reward-points") ||
          hasPermission("reports-fees-list") ||
          hasPermission("reports-attendance-list") ||
          hasPermission("reports-overall-list") ||
          hasPermission("reports-ledger-list") ||
          hasPermission("reports-membership-expiry-renewal-list") ||
          hasPermission("reports-chapter-wise-business-list") ||
          hasPermission("reports-chapter-wise-one-to-one-list") ||
          hasPermission("reports-chapter-wise-referrals-list") ||
          hasPermission("reports-chapter-wise-visitors-list")) && (
          <div className={`sidebar-dropdown-menu ${showReportsSubMenu ? "open" : ""}`}>
            <div
              className="sidebar-dropdown-toggle d-flex justify-content-between align-items-center"
              onClick={toggleReportsSubMenu}
            >
              <div className="d-flex align-items-center">
                <span className="sidebar-icon-wrap me-3">
                  <i className="fa-solid fa-file-invoice"></i>
                </span>
                <span className="dropdown-item-text">Reports</span>
              </div>
              <i className="fa-solid fa-chevron-down dropdown-arrow ms-2 flex-shrink-0"></i>
            </div>
            <div className="sidebar-submenu-collapse">
              <div className="sidebar-submenu-card">
                {hasPermission("reports-tyns-list") && (
                  <Link
                    to="/reports/tyfcbs"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${tyfcbReportsRoutes() ? "active" : ""}`}
                  >
                    TYNs
                  </Link>
                )}
                {hasPermission("reports-biz-given-list") && (
                  <Link
                    to="/reports/biz-given"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${bizgivenReportsRoutes() ? "active" : ""}`}
                  >
                    BIZ Given
                  </Link>
                )}
                {hasPermission("reports-121s-list") && (
                  <Link
                    to="/reports/one-to-one"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${onetooneReportsRoutes() ? "active" : ""}`}
                  >
                    121s
                  </Link>
                )}
                {hasPermission("reports-referrals-list") && (
                  <Link
                    to="/reports/referrals"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${referralReportsRoutes() ? "active" : ""}`}
                  >
                    RFLs
                  </Link>
                )}
                {hasPermission("reports-visitors-list") && (
                  <Link
                    to="/reports/visitors"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${visitorsReportsRoutes() ? "active" : ""}`}
                  >
                    Visitors
                  </Link>
                )}
                {hasPermission("reports-reward-points") && (
                  <Link
                    to="/reports/points"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${pointsRoutes() ? "active" : ""}`}
                  >
                    Reward Points
                  </Link>
                )}
                {hasPermission("reports-fees-list") && (
                  <Link
                    to="/reports/fees"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${feesReportsRoutes() ? "active" : ""}`}
                  >
                    Fees Pending
                  </Link>
                )}
                {hasPermission("reports-attendance-list") && (
                  <Link
                    to="/reports/attendance"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${attendanceReportsRoutes() ? "active" : ""}`}
                  >
                    Attendance Reports
                  </Link>
                )}
                {hasPermission("reports-overall-list") && (
                  <Link
                    to="/reports/overall"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${overallReportsRoutes() ? "active" : ""}`}
                  >
                    Overall Reports
                  </Link>
                )}
                {hasPermission("reports-membership-expiry-renewal-list") && (
                  <Link
                    to="/reports/membership-expiry-renewals"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${membershipExpiryRenewalReportsRoutes() ? "active" : ""}`}
                  >
                    Membership Expiry & Renewals
                  </Link>
                )}
                {hasPermission("reports-ledger-list") && (
                  <Link
                    to="/reports/ledger"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${ledgerReportsRoutes() ? "active" : ""}`}
                  >
                    Incomes & Expenses Ledger
                  </Link>
                )}
                <Link
                  to="/reports/category-wise-members"
                  onClick={closeDrawer}
                  className={`sidebar-submenu-link ${categoryWiseMembersReportsRoutes() ? "active" : ""}`}
                >
                  Chapter members: category wise
                </Link>
              </div>
            </div>
          </div>
        )}

        {(hasPermission("countries-list") ||
          hasPermission("states-list") ||
          hasPermission("regions-list") ||
          hasPermission("chapters-list") ||
          hasPermission("country-admins-list") ||
          hasPermission("state-admins-list") ||
          hasPermission("region-admins-list") ||
          hasPermission("chapter-admins-list") ||
          hasPermission("user-roles-list") ||
          hasPermission("business-category-list") ||
          hasPermission("income-category-list") ||
          hasPermission("expense-category-list") ||
          hasPermission("posts-category-list") ||
          hasPermission("blood-groups-list") ||
          hasPermission("habits-list") ||
          hasPermission("sponsors-category-list") ||
          hasPermission("timers-list") ||
          hasPermission("timer-access-list") ||
          hasPermission("chapter-finance-access-list") ||
          hasPermission("crowns-list")) && (
          <div className={`sidebar-dropdown-menu ${showMastersSubMenu ? "open" : ""}`}>
            <div
              className="sidebar-dropdown-toggle d-flex justify-content-between align-items-center"
              onClick={toggleMastersSubMenu}
            >
              <div className="d-flex align-items-center">
                <span className="sidebar-icon-wrap me-3">
                  <i className="fa-solid fa-sliders"></i>
                </span>
                <span className="dropdown-item-text">Masters</span>
              </div>
              <i className="fa-solid fa-chevron-down dropdown-arrow ms-2 flex-shrink-0"></i>
            </div>
            <div className="sidebar-submenu-collapse">
              <div className="sidebar-submenu-card">
                {hasPermission("countries-list") && (
                  <Link
                    to="/countries"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${countryRoutes() ? "active" : ""}`}
                  >
                    Countries
                  </Link>
                )}
                {hasPermission("states-list") && (
                  <Link
                    to="/states"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${stateRoutes() ? "active" : ""}`}
                  >
                    States
                  </Link>
                )}
                {hasPermission("regions-list") && (
                  <Link
                    to="/regions"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${regionRoutes() ? "active" : ""}`}
                  >
                    Regions
                  </Link>
                )}
                {hasPermission("chapters-list") && (
                  <Link
                    to="/chapters"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${chapterRoutes() ? "active" : ""}`}
                  >
                    Chapters
                  </Link>
                )}
                {hasPermission("country-admins-list") && (
                  <Link
                    to="/country-admin-users"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${countryAdminRoutes() ? "active" : ""}`}
                  >
                    Country Admins
                  </Link>
                )}
                {hasPermission("state-admins-list") && (
                  <Link
                    to="/state-admin-users"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${stateAdminRoutes() ? "active" : ""}`}
                  >
                    State Admins
                  </Link>
                )}
                {hasPermission("region-admins-list") && (
                  <Link
                    to="/region-admin-users"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${regionAdminRoutes() ? "active" : ""}`}
                  >
                    Region Admins
                  </Link>
                )}
                {hasPermission("chapter-admins-list") && (
                  <Link
                    to="/chapter-admin-users"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${chapterAdminRoutes() ? "active" : ""}`}
                  >
                    Chapter Admins
                  </Link>
                )}
                {hasPermission("user-roles-list") && (
                  <Link
                    to="/user-roles"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${userRoleRoutes() ? "active" : ""}`}
                  >
                    User Roles
                  </Link>
                )}
                {hasPermission("business-category-list") && (
                  <Link
                    to="/category"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${categoryRoutes() ? "active" : ""}`}
                  >
                    Business Category
                  </Link>
                )}
                {hasPermission("income-category-list") && (
                  <Link
                    to="/income-category"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${incomeCategoryRoutes() ? "active" : ""}`}
                  >
                    Income Category
                  </Link>
                )}
                {hasPermission("expense-category-list") && (
                  <Link
                    to="/expense-category"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${expenseCategoryRoutes() ? "active" : ""}`}
                  >
                    Expense Category
                  </Link>
                )}
                {hasPermission("posts-category-list") && (
                  <Link
                    to="/posts-category"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${postsCategoryRoutes() ? "active" : ""}`}
                  >
                    Leads Category
                  </Link>
                )}
                {hasPermission("sponsors-category-list") && (
                  <Link
                    to="/sponsors-category"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${sponsorsCategoryRoutes() ? "active" : ""}`}
                  >
                    Sponsors Category
                  </Link>
                )}
                {hasPermission("blood-groups-list") && (
                  <Link
                    to="/blood-groups"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${bloodgroupRoutes() ? "active" : ""}`}
                  >
                    Blood Groups
                  </Link>
                )}
                {hasPermission("habits-list") && (
                  <Link
                    to="/habits"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${habitsRoutes() ? "active" : ""}`}
                  >
                    Habits
                  </Link>
                )}
                {hasPermission("crowns-list") && (
                  <Link
                    to="/crowns"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${crownRoutes() ? "active" : ""}`}
                  >
                    Crowns
                  </Link>
                )}
                {hasPermission("timers-list") && (
                  <Link
                    to="/timers"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${timerRoutes() ? "active" : ""}`}
                  >
                    Timers
                  </Link>
                )}
                {hasPermission("timer-access-list") && (
                  <Link
                    to="/timer-access"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${timerAccessRoutes() ? "active" : ""}`}
                  >
                    Timer Access
                  </Link>
                )}
                {hasPermission("chapter-finance-access-list") && (
                  <Link
                    to="/chapter-finance-access"
                    onClick={closeDrawer}
                    className={`sidebar-submenu-link ${chapterFinanceAccessRoutes() ? "active" : ""}`}
                  >
                    Chapter Finance Access
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}

        {hasPermission("settings-list") && (
          <Link
            to="/settings"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${settingsRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-gear fa-fw me-3"></i>
            <span>Settings</span>
          </Link>
        )}

        {hasPermission("roles-list") && (
          <Link
            to="/roles"
            onClick={closeDrawer}
            className={`list-group-item list-group-item-action d-flex align-items-center ${roleRoutes() ? "active" : ""}`}
          >
            <i className="fa-solid fa-user-shield fa-fw me-3"></i>
            <span>Roles & Permissions</span>
          </Link>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
